var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { NGXLogger } from 'ngx-logger';
import { ContentBaseService } from '../base/contentbase.service';
import { ApiService } from '../../service/api.service';
import { AuAction } from '../../action/au.action';
var SortTreeService = /** @class */ (function (_super) {
    __extends(SortTreeService, _super);
    function SortTreeService(logger, api, action) {
        var _this = _super.call(this, logger, api) || this;
        _this.logger = logger;
        _this.api = api;
        _this.action = action;
        _this.componentName = '';
        _this.move = [];
        _this._subject = new BehaviorSubject(false);
        return _this;
    }
    SortTreeService.prototype.init = function (name) {
        this.componentName = name;
        this.move = [];
        this.setCompRec();
    };
    SortTreeService.prototype.toggle = function (flg) {
        this._subject.next(flg);
    };
    Object.defineProperty(SortTreeService.prototype, "observable", {
        get: function () {
            return this._subject.asObservable();
        },
        enumerable: true,
        configurable: true
    });
    SortTreeService.prototype.setMove = function (move) {
        this.move.push(move);
        this.setCompRec();
    };
    SortTreeService.prototype.setCompRec = function () {
        this.action.setCompRec(this.componentName, { 'items': this.move });
    };
    SortTreeService.decorators = [
        { type: Injectable }
    ];
    /** @nocollapse */
    SortTreeService.ctorParameters = function () { return [
        { type: NGXLogger },
        { type: ApiService },
        { type: AuAction }
    ]; };
    return SortTreeService;
}(ContentBaseService));
export { SortTreeService };
var SortTreeNode = /** @class */ (function () {
    function SortTreeNode() {
        this.children = [];
    }
    return SortTreeNode;
}());
export { SortTreeNode };
var SortMoveNode = /** @class */ (function () {
    function SortMoveNode() {
        this.operation = 'move';
    }
    return SortMoveNode;
}());
export { SortMoveNode };
var SortMoveParams = /** @class */ (function () {
    function SortMoveParams() {
    }
    return SortMoveParams;
}());
//# sourceMappingURL=sort-tree.service.js.map